import { render, staticRenderFns } from "./ProductCsvImport.vue?vue&type=template&id=548bc7fc&scoped=true&lang=pug&"
import script from "./ProductCsvImport.vue?vue&type=script&lang=js&"
export * from "./ProductCsvImport.vue?vue&type=script&lang=js&"
import style0 from "./ProductCsvImport.vue?vue&type=style&index=0&id=548bc7fc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548bc7fc",
  null
  
)

/* custom blocks */
import block0 from "./ProductCsvImport.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports